import React, { useState, useEffect, useRef } from 'react';
import { UTILS } from '../../constants';
import axios from 'axios';
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

export const BackgroundCover = ({ cardDetail, setShowCover, showCover }) => {
  console.log("showCover",showCover);
  
  useEffect(() => {
    let { cover_background_color, cover_image } = cardDetail && cardDetail;
    setShowCover({
      cover_background_color: cover_background_color,
      cover_image: cover_image,
    });
  }, [cardDetail]);

  useEffect(() => {
    // Bind Fancybox after the content has been rendered
    Fancybox.bind("[data-fancybox='gallery']", {
      infinite: false,
    });

    // Cleanup on unmount or when content changes
    return () => {
      Fancybox.destroy();
    };
  }, []);
  // console.log("showCover",showCover);
  // console.log("cardDetail",cardDetail);
  // console.log("showCover",showCover);

  return showCover?.cover_image == null ? (
    ''
  ) : (
    <div className="background-cover">
      <a
        className="image-container container1"
        style={{
          backgroundColor: showCover && showCover?.cover_background_color,
        }}
        // href={UTILS.images_url + cardDetail.cover_image}
        href={
          cardDetail?.cover_time_difference != null
            ? cardDetail?.cover_time_difference > 10
              ? UTILS.images_url + cardDetail.cover_image
              : UTILS.temp_image_url + cardDetail.cover_image
            : UTILS.images_url + cardDetail.cover_image
          // UTILS.images_url + (showCover && showCover?.cover_image)
        }
        data-fancybox="gallery"
      >
        <img
          className="selected-image modal-cover-image"
          id="modal-cover-image"
          // src={showCover && UTILS.images_url + showCover?.cover_image}
          src={
            cardDetail?.cover_time_difference != null
              ? cardDetail?.cover_time_difference > 10
                ? UTILS.images_url + cardDetail.cover_image
                : UTILS.temp_image_url + cardDetail.cover_image
              : UTILS.images_url + cardDetail.cover_image
            // UTILS.images_url + (showCover && showCover?.cover_image)
          }
          alt="Cover Image"
        />
      </a>
    </div>
  );
};
